export default __webpack_public_path__ + "static/media/shape-55.c5918cda.png";